import React from 'react';
import Row from '~/glm/components/shared/guest-import/guest-import-spreadsheet/row';
import exampleData from './example-data';
import styles from './example-input.scss';

const ExampleInput = () => (
  <div className={styles.exampleRows}>
    {exampleData.map((guest, index) => (
      <div className={styles.rowWrapper} key={index}>
        <Row handleTrackValidationError={() => null} disabled rowId={index} guest={guest} />
      </div>
    ))}
  </div>
);

export default ExampleInput;
